/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "smackApi",
            "endpoint": "https://uldr3bsvxb.execute-api.us-east-1.amazonaws.com/main",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:a3247451-975b-4eb7-8a64-80c5667a3182",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_D4bFEn49Q",
    "aws_user_pools_web_client_id": "4bktn59vd998bmjl89ca2q7bm0",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "APIKeys-main",
            "region": "us-east-1"
        },
        {
            "tableName": "FeedAPIKeys-main",
            "region": "us-east-1"
        },
        {
            "tableName": "PlatformPreferences-main",
            "region": "us-east-1"
        },
        {
            "tableName": "PodcastEpisodesV2-main",
            "region": "us-east-1"
        },
        {
            "tableName": "PodcastFeedsV2-main",
            "region": "us-east-1"
        },
        {
            "tableName": "SocialPosts-main",
            "region": "us-east-1"
        },
        {
            "tableName": "UserBilling-main",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "smack-temp-images1c7d9-main",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
